<nz-page-header [nzTitle]="ticketMode + ' Workflows'"></nz-page-header>

<div class="row gap-3">
	<div class="col">
		<!-- Advanced Pie Chart -->
		<div class="col-md-6">
			<div class="chart-row">
				<div class="chart-container">
					<ngx-charts-pie-chart [view]="[500, 400]" [scheme]="colorScheme"
						[results]="slaChartData" [gradient]="true" [doughnut]="true"
						[labels]="false" [legend]="false" (select)="onSliceSelect($event)">
					</ngx-charts-pie-chart>
					<div class="center-label">
						<div class="label-text">Total</div>
						<div class="total-number">{{ countAllTickets }}</div>
					</div>
				</div>

				<div class="custom-legend">
					<div class="legend-item">
						<span class="legend-color within"></span>
						<div class="legend-text">
							<div class="legend-value">{{ countWithinSla }}</div>
							<div class="legend-label">Within SLA</div>
							<div class="legend-percent">{{(countWithinSla / countAllTickets)
								* 100 | number : "1.0-0"}}%</div>
						</div>
					</div>

					<div class="legend-item">
						<span class="legend-color nearing"></span>
						<div class="legend-text">
							<div class="legend-value">
								{{ countNearingSla }}
							</div>
							<div class="legend-label">Nearing SLA</div>
							<div class="legend-percent">{{(countNearingSla /
								countAllTickets) * 100 | number : "1.0-0"}}%</div>
						</div>
					</div>

					<div class="legend-item">
						<span class="legend-color out"></span>
						<div class="legend-text">
							<div class="legend-value">{{ countOutOfSla }}</div>
							<div class="legend-label">Out of SLA</div>
							<div class="legend-percent">{{(countOutOfSla / countAllTickets)
								* 100 | number : "1.2-2"}}%</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="row">
	<div class="col">
		<div class="section-title">Visible Workflows</div>
		<div class="wf-inline-list">
			<label nz-checkbox *ngFor="let workflow of workflows; trackBy: trackByDto"
				[(ngModel)]="workflow.visible" (ngModelChange)="visibleWorkflowsChanged()">
				{{ workflow.payload.label }}
			</label>
		</div>
	</div>
	<div class="col-3" *hasPermission="['TicketAdmin']">
		<nz-select class="float-end" style="width: 300px" nzShowSearch nzPlaceHolder="Search agent"
			[ngModel]="selectedAgent" [nzFilterOption]="filterOption" (ngModelChange)="onSelect($event)">
			<nz-option [nzValue]="undefined" [nzLabel]="'All Users'"></nz-option>
			<nz-option [nzValue]="getAuthedAgent()" [nzLabel]="'My Tickets'"></nz-option>
			<nz-option nzDisabled="true" nzLabel="──────────"></nz-option>
			<nz-option *ngFor="let agent of agents" [nzLabel]="agent.firstName + ' ' + agent.lastName"
				[nzValue]="agent"></nz-option>
		</nz-select>
	</div>
</div>

<h3 class="float-start">Where to Focus</h3>
<nz-table #ticketsTable [nzBordered]="true" [nzLoading]="loading" [nzData]="tickets" [nzFrontPagination]="true"
	[nzTotal]="26" [nzPageSize]="5" [nzPageIndex]="1" [nzShowSizeChanger]="true"
	[nzPageSizeOptions]="[5, 10, 15, 20, 25, 50, 100]" (nzQueryParams)="onQueryParamsChange(getThis(), $event)">
	<thead>
		<tr>
			<th>Ref</th>
			<th>Ticket type</th>
			<th>Membership number</th>
			<th>Member details</th>
			<th>Category</th>
			<th>Status</th>
			<th>Last updated</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let ticket of ticketPage; let i = index" class="cursor-pointer"
			(dblclick)="openTicket(ticket)">
			<td>{{ ticket.ticketReference }}</td>
			<td>{{ ticket.workflowLabel }}</td>
			<td>{{ ticket.membership?.membershipNumber || '_' }}</td>
			<td>{{ ticket.member.name }} {{ ticket.member.surname }}</td>
			<td>{{ ticket.focusCategory || '_' }}</td>
			<td class="p-0 m-0">
				<nz-alert [nzBanner]="true" [nzType]="getSlaClass(ticket)"
					[nzDescription]="ticket.currentStepAndStateLabel">
					{{ ticket.currentStepAndStateLabel }}
				</nz-alert>
			</td>
			<td>{{ ticket.lastActionedAt | date }}</td>
		</tr>
	</tbody>
</nz-table>

<div class="workflow-scroll">
	<ng-container *ngFor="let workflow of workflows; trackBy: trackByDto">
		<div class="workflow-card" *ngIf="workflow.visible">
			<nz-card [nzTitle]="'Workflow: ' + workflow.payload.label">
				<nz-timeline>
					<nz-timeline-item *ngFor="
							let step of workflow.payload.steps;
							trackBy: trackByDto
						">
						<h6 class="cursor-pointer" (click)="openStep(workflow.payload, step)">
							{{ step.label }}
						</h6>
						<ul>
							<li *ngFor="let state of step.statuses" (click)="
									openStatus(workflow.payload, step, state)
								" class="cursor-pointer">
								{{ state.label }}
								<span *ngIf="state.ticketAllCountWithinSla ?? 0 > 0"
									class="badge text-bg-success me-1">
									{{ state.ticketAllCountWithinSla }}
								</span>
								<span *ngIf="state.ticketAllCountNearingSlaLimit ?? 0 > 0"
									class="badge text-bg-warning me-1">
									{{ state.ticketAllCountNearingSlaLimit }}
								</span>
								<span *ngIf="state.ticketAllCountOutOfSla ?? 0 > 0"
									class="badge text-bg-danger me-1">
									{{ state.ticketAllCountOutOfSla }}
								</span>
							</li>
						</ul>
					</nz-timeline-item>
				</nz-timeline>
			</nz-card>
		</div>
	</ng-container>
</div>